var confettiInterval;
const Confettiful = function (el) {
  this.el = el;
  this.containerEl = null;
  this.confettiFrequency = 3;
  this.confettiColors = ["#fce18a", "#ff726d", "#b48def", "#f4306d"];
  this.confettiAnimations = ["slow", "medium", "fast"];
  this._setupElements();
  this._renderConfetti();
};

Confettiful.prototype._setupElements = function () {
  const containerEl = this.el.querySelector(".confetti-container");
  const elPosition = this.el.style.position;

  if (elPosition !== "relative" || elPosition !== "absolute") {
    this.el.style.position = "absolute";
  }
  this.containerEl = containerEl;
};

Confettiful.prototype._renderConfetti = function () {
  confettiInterval = setInterval(() => {
    const confettiEl = document.createElement("div");
    const confettiSize = Math.floor(Math.random() * 3) + 7 + "px";
    const confettiBackground =
      this.confettiColors[
        Math.floor(Math.random() * this.confettiColors.length)
      ];
    const confettiLeft = Math.floor(Math.random() * this.el.offsetWidth) + "px";
    const confettiAnimation =
      this.confettiAnimations[
        Math.floor(Math.random() * this.confettiAnimations.length)
      ];

    confettiEl.classList.add(
      "confetti",
      "confetti--animation-" + confettiAnimation
    );
    confettiEl.style.left = confettiLeft;
    confettiEl.style.width = confettiSize;
    confettiEl.style.height = confettiSize;
    confettiEl.style.backgroundColor = confettiBackground;

    confettiEl.removeTimeout = setTimeout(function () {
      confettiEl.parentNode.removeChild(confettiEl);
    }, 3000);

    this.containerEl.appendChild(confettiEl);
  }, 25);
};

window.addEventListener("load", (event) => {
  getATCelement();
  getQuantityElement();
  getCartItemRemoveElements();
  cartGiftWrapElement();
});

function getATCelement(section = document) {
  let cartATCElement = section.querySelectorAll("[data-add-to-cart]");
  let cartDrawer = document.querySelector(
    "#ajax-cart-drawer[data-side-drawer]"
  );
  //let cartDrawerbackground = section.querySelector('.drawer_background');
  Array.from(cartATCElement).forEach(function (element) {
    initATC(element, cartDrawer);
  });
}

function initATC(element, cartDrawer) {
  element.addEventListener("click", function (event) {
    event.preventDefault();
    let form = element.closest("form");
    let formParent = element.closest("[data-product-wrapper]");
    if (
      element
        .closest(".shopify-section")
        .querySelector("[data-sticky-products]")
    ) {
      formParent = element.closest(".shopify-section");
    }
    if (element.closest("[data-sticky-products]")) {
      let formId = element.getAttribute("data-form");
      if (formParent.querySelector("#" + formId)) {
        form = formParent.querySelector("#" + formId);
      }
    }
    Array.from(formParent.querySelectorAll("[data-form-error]")).forEach(
      function (errorContainer) {
        errorContainer.classList.add("hidden");
        errorContainer.textContent = "";
      }
    );
    element.setAttribute("disabled", true);
    let giftCardWrapper = formParent.querySelector("[data-gift-card-box]");
    if (giftCardWrapper) {
      let errormessageWrapper = giftCardWrapper.querySelector(
        "[data-gift-card-errors]"
      );
      let errorMessage = errormessageWrapper.querySelector(".error-message");
      errormessageWrapper.classList.add("hidden");
      errorMessage.innerHTML = "";
      // giftCardErrors
    }
    if (element.classList.contains("bundle-product-button")) {
      formParent = element.closest("[data-product-bundle-wrapper]");
    }
    addItemtoCart(form, formParent, element, cartDrawer);
  });
}




function addItemtoCart(form, formParent, element, cartDrawer) {
  const config = {
    method: "POST",
    headers: {
      "X-Requested-With": `XMLHttpRequest`,
      Accept: `application/javascript`,
    },
  };
  let sectionId = "ajax-cart-drawer";
  let section = "";
  var baseUrl = window.location.pathname;
  if (baseUrl.indexOf("/cart") > -1) {
    let cartSection = document.querySelector("[data-cart-wrapper]");
    section = cartSection;
    if (cartSection) {
      sectionId = cartSection.dataset.section;
    }
  }
  const formData = new FormData(form);
  formData.append("sections", [sectionId]);
  config.body = formData;
  fetch(cartAddUrl, config)
    .then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const cart = JSON.parse(responseText);
      if (cart.status) {
        if (cart.errors) {
          
          let giftCardWrapper = formParent.querySelector(
            "[data-gift-card-box]"
          );
          if (giftCardWrapper && cart.errors["email"]) {
            let errormessageWrapper = giftCardWrapper.querySelector(
              "[data-gift-card-errors]"
            );
            let giftCardEmail = formParent.querySelector("[type=email]");
            let errorMessage =
              errormessageWrapper.querySelector(".error-message");
            errorMessage.innerHTML =
              giftCardEmail.dataset.attr + " " + cart.errors["email"];
            errormessageWrapper.classList.remove("hidden");
            //giftCardErrors
          }
        } else {
          Array.from(formParent.querySelectorAll("[data-form-error]")).forEach(
            function (errorContainer) {
              errorContainer.textContent = cart.description;
              errorContainer.classList.remove("hidden");
              if (!isOnScreen(errorContainer)) {
                  var scrollDiv = errorContainer.offsetTop;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
              }
            }
          );
        }
        element.removeAttribute("disabled");
        return false;
      }
      if (carType == "page") {
        window.location.href = "/cart";
        return false;
      }
      if (shakeEffect) {
        element.classList.add("shake");
        setTimeout(() => {
          element.classList.remove("shake");
        }, 700);
      }
      if (hapticFeedbackStatus) {
        const canVibrate = window.navigator.vibrate;
        if (canVibrate) window.navigator.vibrate(500);
      }
      if (document.getElementById("cartAlert")) {
        document.getElementById("cartAlert").play();
      }
      if (baseUrl.indexOf("/cart") > -1) {
        let updatedCartHtml = new DOMParser()
          .parseFromString(cart.sections[sectionId], "text/html")
          .querySelector(".shopify-section");
        let updatedCartContent = updatedCartHtml.querySelector(
          "[data-cart-wrapper]"
        );
        let cartCount = parseInt(
          updatedCartContent.getAttribute("data-item-count")
        );

        cartCountUpdate(cartCount);
        // section.innerHTML = updatedCartHtml.innerHTML;
        section.innerHTML = updatedCartContent.innerHTML;
        element.removeAttribute("disabled");
        setTimeout(() => {
          if (cartCount > 0) {
            getQuantityElement(section);
            cartNoteUpdate(section);
            getCartItemRemoveElements(section);
            cartGiftWrapElement(section);
            cartTotalprice(section);
            shippingEstimates();
          }
        }, 500);
        var scrollDiv = section.offsetTop;
        window.scrollTo({ top: scrollDiv, behavior: "smooth" });
      } else {
        let updateCartHtml = new DOMParser()
          .parseFromString(cart.sections[sectionId], "text/html")
          .querySelector(".shopify-section");
        let updateCartContent = updateCartHtml.innerHTML;
        let cartBody = document.querySelector("[data-cart-drwaer-body]");
        let cartItemcount = 0;
        let cartItemtotalprice;
        if (updateCartHtml.querySelector("[data-cart-wrapper]")) {
          cartItemcount = parseInt(
            updateCartHtml
              .querySelector("[data-cart-wrapper]")
              .getAttribute("data-item-count")
          );
          cartItemtotalprice = updateCartHtml
            .querySelector("[data-cart-wrapper]")
            .getAttribute("data-item-total");
        }
        cartBody.innerHTML = updateCartContent;
        if (cartItemcount > 0) {
          getQuantityElement(cartBody);
        }
        cartCountUpdate(cartItemcount);
        cartNoteUpdate();
        // SidedrawerEventInit(cartDrawer);
        getCartItemRemoveElements(cartDrawer);
        cartGiftWrapElement(cartDrawer);
        cartTermhandlerClick();
        cartTermsHandler();
        renderRecommendedForLastViewedProduct();
        renderRecentlyViewedProducts();

        setTimeout(function () {
          let Cartdrawer = document.querySelector(".cart-drawer");
          let Quickview = document.querySelector(".quickview-drawer");
          let Comparemodel = document.querySelector("[data-compare-model]");
          if (Quickview) {
            Quickview.classList.remove("sidebar-visible");
            setTimeout(function () {
              Quickview.style.display = "none";
            }, 300);
          }
          if(Comparemodel){
            if (Cartdrawer.classList.contains("sidebar-visible") && Comparemodel.querySelector(".compare-modal-content")) {
              Comparemodel.querySelector(
                ".compare-modal-content"
              ).classList.remove("popup-visible");
            }
          }
        }, 100);
        setTimeout(function () {
          if(cartDrawer){
            cartDrawer.classList.add("sidebar-visible");
          }
          setTimeout(function () {
            focusElementsRotation(cartDrawer);
            previousFocusElement = element;
          }, 500);
        }, 500);

        let recommendProducts = cartDrawer.querySelector(
          "[data-recommendation-popup]"
        );
        if (
          recommendProducts &&
          !recommendProducts.classList.contains("active")
        ) {
          setTimeout(() => {
            recommendProducts.classList.add("active");
          }, 1000);
          slideshowElements();
        }
        cartDrawer.style.display = "flex";
        document.querySelector("body").classList.add("no-scroll");
        document.querySelector("body").classList.add("sidedrawer-open");
        element.removeAttribute("disabled");
      }
      if(document.querySelector('[data-cart-shipping]') && document.querySelector('[data-cart-shipping]').getAttribute('data-barwidth') == '100%'){
        if(document.querySelector('.confetti-container-wrapper') && (localStorage.confettiEffect == 'false' || localStorage.confettiEffect == undefined )){
          window.confettiful = new Confettiful(document.querySelector('.confetti-container-wrapper'));
          localStorage.confettiEffect = "true";
          setTimeout(function () {
            clearInterval(confettiInterval)
          },3000);
        }
      }
    })
    .catch(function (err) {
      element.removeAttribute("disabled");
    });
}




//Quantity change
function getQuantityElement(section = document) {
  let quantityElements = section.querySelectorAll("[data-quantity-wrapper]");
  Array.from(quantityElements).forEach(function (element) {
    initQuantityAction(element);
  });
}

function initQuantityAction(element) {
  
  let quantityInput = element.querySelector("[data-quantity-input]");
  let stickyQuantityInput;
  if (
    element.closest(".shopify-section") &&
    element.closest(".shopify-section").querySelector("#sticky_quantity")
  ) {
    stickyQuantityInput = element
      .closest(".shopify-section")
      .querySelector("#sticky_quantity");
  }
  let quantityIncreament = element.querySelector("[data-quantity-increment]");
  let quantityDecreament = element.querySelector("[data-quantity-decrement]");
  if (quantityInput) {
    quantityInput.onkeydown = function (e) {
      if (
        !(
          (e.keyCode > 95 && e.keyCode < 106) ||
          (e.keyCode > 47 && e.keyCode < 58) ||
          e.keyCode == 8 ||
          e.keyCode == 9 ||
          (e.keyCode > 36 && e.keyCode < 41)
        )
      ) {
        return false;
      }
    };
    quantityInput.addEventListener("input", function (event) {
      let currentValue = parseInt(quantityInput.value);
      if (isNaN(currentValue)) {
        currentValue = 1;
      }
      if (stickyQuantityInput) {
        stickyQuantityInput.value = currentValue;
      }
    });
    if (quantityInput.classList.contains("ajax-cart-update")) {
      quantityInput.addEventListener("change", function (event) {
        let currentValue = parseInt(quantityInput.value);
        let section = quantityInput.closest("[data-cart-wrapper]");
        let cartItem = quantityInput.closest("[data-cart-item]");
        cartItem.classList.add("disabled");
        let line = quantityInput.dataset.line;
        changeCartItem(line, currentValue, section, cartItem);
      });
    }
  }
  quantityIncreamentDecreament(
    quantityIncreament,
    quantityDecreament,
    quantityInput,
    stickyQuantityInput
  );
}

function quantityIncreamentDecreament(
  quantityIncreament,
  quantityDecreament,
  quantityInput,
  stickyQuantityInput
) {
  // if (quantityIncreament) {
    
  //   quantityIncreament.addEventListener("click", function (event) {
  //     event.preventDefault();
  //     quantityIncreament;
  //     let currentValue = parseInt(quantityInput.value);

  //     updatedValue = currentValue + 1;
  //     if (isNaN(updatedValue)) {
  //       updatedValue = 1;
  //     }
  //     quantityInput.value = updatedValue;
  //     if (stickyQuantityInput) {
  //       stickyQuantityInput.value = updatedValue;
  //     }
  //     if (quantityIncreament.classList.contains("ajax-cart-update")) {
  //       quantityIncreament.setAttribute("aria-disabled", "true");
  //       quantityIncreament.classList.add("disabled-minus")
  //       const cart_drawer_body= document.querySelector(".cart-drawer-content");
  //       if(cart_drawer_body){
  //       cart_drawer_body.classList.add("add-overlay")
  //       }
  //       quantityUpdate(quantityInput);
        
  //     }
  //     updateDecrementState()
      

      
  //   });
  // }
  // if (quantityDecreament) {
  //   quantityDecreament.addEventListener("click", function (event) {
  //     event.preventDefault();

  //     let currentValue = parseInt(quantityInput.value);
  //     updatedValue = currentValue - 1;
  //     if (isNaN(updatedValue)) {
  //       updatedValue = 1;
        
  //     }
  //     if (updatedValue > 0) {
  //       quantityInput.value = updatedValue;
  //       if (stickyQuantityInput) {
  //         stickyQuantityInput.value = updatedValue;
  //         quantityInput.value = updatedValue;
  //       }
  //     }


              
  //       if (quantityDecreament.classList.contains("ajax-cart-update")) {
  //         quantityDecreament.setAttribute("aria-disabled", "true");
  //         quantityDecreament.classList.add("disabled-minus");

  //         quantityDecreament.addEventListener(
  //           "click",
  //           e => e.preventDefault(),
  //           { once: true }
  //         );

  //         const cart_drawer_body = document.querySelector(".cart-drawer-content");
  //         if (cart_drawer_body) {
  //           cart_drawer_body.classList.add("add-overlay");
  //         }

  //         quantityInput.value = updatedValue;
  //         quantityUpdate(quantityInput);
  //       }

  //    updateDecrementState()
      
  //   });
  // }


  if (quantityIncreament) {
    quantityIncreament.addEventListener("click", function (event) {
      event.preventDefault();
      
      // CHECK IF ALREADY UPDATING
      if (quantityIncreament.classList.contains("updating")) {
        return;
      }
      
      let currentValue = parseInt(quantityInput.value);
      updatedValue = currentValue + 1;
      if (isNaN(updatedValue)) {
        updatedValue = 1;
      }
      quantityInput.value = updatedValue;
      if (stickyQuantityInput) {
        stickyQuantityInput.value = updatedValue;
      }
      if (quantityIncreament.classList.contains("ajax-cart-update")) {
        // MARK AS UPDATING
        quantityIncreament.classList.add("updating");
        quantityDecreament.classList.add("updating");
        
        // quantityIncreament.setAttribute("aria-disabled", "true");
        // quantityIncreament.classList.add("disabled-minus")
        const cart_drawer_body= document.querySelector(".cart-drawer-content");
        if(cart_drawer_body){
          cart_drawer_body.classList.add("add-overlay")
        }
        quantityUpdate(quantityInput);
      }
      updateDecrementState()
    });
  }
  
  if (quantityDecreament) {
    quantityDecreament.addEventListener("click", function (event) {
      event.preventDefault();
      
      // CHECK IF ALREADY UPDATING
      if (quantityDecreament.classList.contains("updating")) {
        return;
      }

      let currentValue = parseInt(quantityInput.value);
      updatedValue = currentValue - 1;
      if (isNaN(updatedValue)) {
        updatedValue = 1;
      }
      if (updatedValue > 0) {
        quantityInput.value = updatedValue;
        if (stickyQuantityInput) {
          stickyQuantityInput.value = updatedValue;
          quantityInput.value = updatedValue;
        }
      }

      if (quantityDecreament.classList.contains("ajax-cart-update")) {
        // MARK AS UPDATING
        quantityIncreament.classList.add("updating");
        quantityDecreament.classList.add("updating");
        
        // quantityDecreament.setAttribute("aria-disabled", "true");
        // quantityDecreament.classList.add("disabled-minus");
        // quantityDecreament.addEventListener(
        //   "click",
        //   e => e.preventDefault(),
        //   { once: true }
        // );
        const cart_drawer_body = document.querySelector(".cart-drawer-content");
        if (cart_drawer_body) {
          cart_drawer_body.classList.add("add-overlay");
        }
        quantityInput.value = updatedValue;
        quantityUpdate(quantityInput);
      }
      updateDecrementState()
    });
  }

  function updateDecrementState() {
  if (parseInt(quantityInput.value) === 1) {
  quantityDecreament.classList.add("disabled-minus");
  quantityDecreament.classList.add("hide-minus");
  quantityDecreament.setAttribute("aria-disabled", "true");
  quantityDecreament.setAttribute("tabindex", "-1");
} else {
  quantityDecreament.classList.remove("disabled-minus");
   quantityDecreament.classList.remove("hide-minus");
  quantityDecreament.removeAttribute("aria-disabled");
  quantityDecreament.setAttribute("tabindex", "0");
}


const mainquantitywrapper = quantityInput.closest('.pdp-main-product-qty');

if(mainquantitywrapper != null){
if(parseInt(quantityInput.value, 10) < 10){

  if(mainquantitywrapper.classList.contains('quantity-added-grid'))
 { mainquantitywrapper.classList.remove('quantity-added-grid');
 }

}
 }

}

 updateDecrementState();
 
}


function getCartItemRemoveElements(section = document) {
  let cartItemRemoveElements = section.querySelectorAll("[data-item-remove]");
  Array.from(cartItemRemoveElements).forEach(function (element) {
    initCartItemRemove(element);
    if (element) {
      cartTotalprice();
    }
  });
}



// function getCartItemRemoveElements(section = document) {
//   const cartWrapper = section.querySelector("[data-cart-wrapper]");
//   if (!cartWrapper) return;

//   cartWrapper.addEventListener("click", function (event) {
//     const removeButton = event.target.closest("[data-item-remove]");
//     if (!removeButton) return;

//     event.preventDefault();

//     // Add disabled class to the cart item
//     const cartItem = removeButton.closest("[data-cart-item]");
//     if (cartItem) {
//       cartItem.classList.add("disabled");
//     }

//     const line = removeButton.dataset.line;
//     changeCartItem(line, 0, section, cartItem);

//     // Optionally recalculate total price
//     cartTotalprice();
//   });
// }




function cartGiftWrapElement(section = document) {
  let cartGiftWrap = section.querySelector("[data-gift-atc]");
  if (cartGiftWrap) {
    cartGiftWrap.addEventListener("click", (event) => {
      event.preventDefault();
      let formParent = cartGiftWrap.closest("[data-gift-card]");
      let form = formParent.querySelector("form");
      addItemtoCart(form, formParent, cartGiftWrap);
    });
  }
}

function initCartItemRemove(element) {
  element.addEventListener("click", (event) => {
    event.preventDefault();
    let section = element.closest("[data-cart-wrapper]");
    element.closest("[data-cart-item]").classList.add("disabled");
    let line = element.dataset.line;
    changeCartItem(line, 0, section, element.closest("[data-cart-item]"));
  });
}




function quantityUpdate(quantityInput) {
  let section = quantityInput.closest("[data-cart-wrapper]");
  let cartItem = quantityInput.closest("[data-cart-item]");
  // cartItem.classList.add("disabled");
  let quantity = parseInt(quantityInput.value);
  let line = quantityInput.dataset.line;
  changeCartItem(line, quantity, section, cartItem);
}


function delegateCartQuantityUpdates(section = document) {
  const cartWrapper = section.querySelector("[data-cart-wrapper]");
  if (!cartWrapper) return;

  cartWrapper.addEventListener("change", function (event) {
    const quantityInput = event.target.closest("[data-quantity-input]");
    if (!quantityInput) return;

    quantityUpdate(quantityInput);
  });
}

function cartContentUpdate(cart, sectionId) {
  let updatedCartHtml = new DOMParser()
    .parseFromString(cart.sections[sectionId], "text/html")
    .querySelector(".shopify-section");
  let cartBody = document.querySelector("[data-cart-wrapper]");
  if (sectionId == "ajax-cart-drawer") {
    cartBody = document.querySelector("[data-cart-drwaer-body]");
  }
  if (cart.item_count > 0) {
    let cartCount = 0;
    cartCount = parseInt(
      updatedCartHtml
        .querySelector("[data-cart-wrapper]")
        .getAttribute("data-item-count")
    );
    cartCountUpdate(cartCount);
    //let cartTotalprice = cartBody.querySelector('[data-cart-wrapper]').getAttribute('data-item-total');
    //  cartTotalpriceUpdate(cartTotalprice);
    if (
      cartBody.querySelector("[data-cart-form]") &&
      updatedCartHtml.querySelector("[data-cart-form]")
    ) {
      cartBody.querySelector("[data-cart-form]").innerHTML =
        updatedCartHtml.querySelector("[data-cart-form]").innerHTML;
    }
    if (
      document.querySelector("[data-cart-item-count]") &&
      updatedCartHtml.querySelector("[data-cart-item-count]")
    ) {
      document.querySelector("[data-cart-item-count]").innerHTML =
        updatedCartHtml.querySelector("[data-cart-item-count]").innerHTML;
    }
    if (
      document.querySelector("[data-cart-note-wrapper]") &&
      updatedCartHtml.querySelector("[data-cart-note-wrapper]")
    ) {
      document.querySelector("[data-cart-note-wrapper]").innerHTML =
        updatedCartHtml.querySelector("[data-cart-note-wrapper]").innerHTML;
    }
    if (
      cartBody.querySelector("[data-cart-shipping]") &&
      updatedCartHtml.querySelector("[data-cart-shipping]")
    ) {
      // cartBody.querySelector('[data-cart-shipping]').innerHTML =  updatedCartHtml.querySelector('[data-cart-shipping]').innerHTML;
      let delay = 0;
      if (
        !cartBody
          .querySelector("[data-cart-shipping-bar]")
          .classList.contains("active")
      ) {
        cartBody
          .querySelector("[data-cart-shipping-bar]")
          .classList.add("active");
        delay = 150;
      }
      cartBody.querySelector("[data-cart-shipping-text]").textContent =
        updatedCartHtml.querySelector("[data-cart-shipping-text]").textContent;
      setTimeout(function () {
        cartBody
          .querySelector("[data-cart-shipping-bar]")
          .style.setProperty(
            "width",
            updatedCartHtml.querySelector("[data-cart-shipping]").dataset
              .barwidth
          );
        if (
          cartBody.querySelector("[data-cart-shipping-bar]").style.width ==
          "100%"
        ) {
          setTimeout(function () {
            document
              .querySelector("[data-cart-shipping]")
              .classList.add("shipping-full");
            if (
              document.querySelector(".confetti-container-wrapper") &&
              (localStorage.confettiEffect == "false" ||
                localStorage.confettiEffect == undefined)
            ) {
              window.confettiful = new Confettiful(
                document.querySelector(".confetti-container-wrapper")
              );
              localStorage.confettiEffect = "true";
            }
            setTimeout(function () {
              clearInterval(confettiInterval);
            }, 3000);
          }, 100);
        } else {
          document
            .querySelector("[data-cart-shipping]")
            .classList.remove("shipping-full");
          localStorage.confettiEffect = "false";
          clearInterval(confettiInterval);
        }
      }, delay);
    }
    if (
      cartBody.querySelector("[data-cart-prices]") &&
      updatedCartHtml.querySelector("[data-cart-prices]")
    ) {
      cartBody.querySelector("[data-cart-prices]").innerHTML =
        updatedCartHtml.querySelector("[data-cart-prices]").innerHTML;
    }
    if (
      cartBody.querySelector("[data-gift-card]") &&
      updatedCartHtml.querySelector("[data-gift-card]")
    ) {
      cartBody.querySelector("[data-gift-card]").innerHTML =
        updatedCartHtml.querySelector("[data-gift-card]").innerHTML;
    }
    if (sectionId != "ajax-cart-drawer") {
      shippingEstimates(cartBody);
    }
    getAllDetails(cartBody);
    const cart_drawer_body = document.querySelector(".cart-drawer-content");
    if(!cart_drawer_body){
    getQuantityElement(cartBody);
    }
    cartNoteUpdate(cartBody);
    getCartItemRemoveElements(cartBody);
    SidedrawerEventInit(cartBody);
    cartGiftWrapElement(cartBody);
  } else {
    localStorage.confettiEffect = "false";
    clearInterval(confettiInterval);
    if (sectionId == "ajax-cart-drawer") {
      let updateCartContent = updatedCartHtml.innerHTML;
      let cartBody = document.querySelector("[data-cart-drwaer-body]");
      cartBody.innerHTML = updateCartContent;
      SidedrawerEventInit(cartBody);
    } else {
      cartBody.innerHTML = updatedCartHtml.querySelector(
        "[data-cart-wrapper]"
      ).innerHTML;
    }
    let cartpriceSelector = document.querySelector("[data-header-cart-total]");
    let cartEmptyprice = document.querySelector("[data-cart-empty]");
    if (cartEmptyprice && cartpriceSelector) {
      cartpriceSelector.textContent = "";
      cartpriceSelector.classList.add("hidden");
    }
  }
}

function cartCountUpdate(itemCount) {
  let cartCountSelectors = document.querySelectorAll(
    "[data-header-cart-count]"
  );
  document
    .querySelector("[data-cart-wrapper]")
    .setAttribute("data-item-count", itemCount);
  Array.from(cartCountSelectors).forEach(function (cartCountSelector) {
    if (itemCount > 0) {
      if (itemCount > 99) {
        cartCountSelector.textContent = "";
        cartCountSelector
          .closest(".cart.header-icons-link")
          .classList.add("dot-icon");
      } else {
        cartCountSelector.textContent = itemCount;
        cartCountSelector
          .closest(".cart.header-icons-link")
          .classList.remove("dot-icon");
      }
      cartCountSelector.classList.remove("hidden");
    } else {
      cartCountSelector.textContent = "";
      cartCountSelector.classList.add("hidden");
    }
    // if (itemCount == 1) {
    //     let itemText = cartCountSelector.getAttribute('data-item-text');
    //     document.querySelector('.cart-item-text').textContent = itemText;
    // }
    // else
    // {
    //     let itemsText = cartCountSelector.getAttribute('data-items-text');
    //     document.querySelector('.cart-item-text').textContent = itemsText;
    // }
  });
}

function cartTotalprice(section = document) {
  let cartSection = section.querySelector("[data-cart-wrapper]");
  let cartpriceSelector = document.querySelector("[data-header-cart-total]");
  if (cartSection) {
    let cartPrice = section.querySelector(
      "[data-cart-prices] [data-cart-final-price]"
    ).textContent;
    cartSection.setAttribute("data-item-total", cartPrice);
    let cartSubtotalprice = cartSection.getAttribute("data-item-total");
    let cartQuantity = cartSection.getAttribute("data-item-count");
    if (cartQuantity > 0 && cartpriceSelector) {
      cartpriceSelector.textContent = cartSubtotalprice;
      cartpriceSelector.classList.remove("hidden");
    }
  }
}

function cartNoteUpdate() {
  let cartNoteElements = document.querySelectorAll("[data-cart-note]");
  var cartNoteTyping;
  Array.from(cartNoteElements).forEach(function (element) {
    element.addEventListener("keydown", (event) => {
      clearTimeout(cartNoteTyping);
    });
    element.addEventListener("keyup", (event) => {
      clearTimeout(cartNoteTyping);
      cartNoteTyping = setTimeout(function () {
        const body = JSON.stringify({
          note: element.value,
        });
        fetch(cartUpdateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
          body,
        }).then((response) => {
          return response.text();
        });
      }, 1000);
    });
  });
}
/* Cart change item event start */

changeCartItem = function (line, quantity, section, cartItem) {
  let sectionId = section.dataset.section;
  let allErrorSelectors = section.querySelectorAll(".cart-item-error");
  Array.from(allErrorSelectors).forEach(function (errorSelector) {
    errorSelector.querySelector("[data-error-text]").innerHTML = "";
    errorSelector.style.display = "none";
  });
  const body = JSON.stringify({
    line,
    quantity,
    sections: [sectionId],
  });
  fetch(cartChangeUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/json` },
    body,
  })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const cart = JSON.parse(state);
      document.querySelectorAll(".quantity-button.updating").forEach(btn => {
        btn.classList.remove("updating");
      });
      if (cart.status) {
        const drawerBody = document.querySelector("[data-cart-drwaer-body]");
        if(drawerBody){
       SidedrawerEventInit(drawerBody)
       renderRecommendedForLastViewedProduct();
       renderRecentlyViewedProducts();
          }
        // if (cartItem.querySelector(".cart-item-error")) {
        //    updateCartDrawerContent()
        //   let quantityWrappers = cartItem.querySelectorAll(".quantity-input");
        //   cartItem.querySelector("[data-error-text]").innerHTML = cart.message;
        //   cartItem.querySelector(".cart-item-error").style.display = "block";
        //   Array.from(quantityWrappers).forEach(function (quantity) {
        //     quantity.value = quantity.getAttribute("data-previous-value");
        //   });
        //   cartItem.classList.remove("disabled");
        // }

        if (cartItem.querySelector(".cart-item-error")) {
         
          if(drawerBody){
  updateCartDrawerContent().then(() => {
    
    if (!drawerBody) return;

    const line = cartItem.querySelector("[data-quantity-input]").dataset.line;
    const updatedCartItem = drawerBody.querySelector(`[data-line="${line}"]`)?.closest("[data-cart-item]");
    if (updatedCartItem) {
      const errorContainer = updatedCartItem.querySelector(".cart-item-error");
      const errorText = errorContainer?.querySelector("[data-error-text]");
      if (errorText && errorContainer) {
        errorText.textContent = cart.message;
        errorContainer.style.display = "block";
      }
      updatedCartItem.classList.remove("disabled");
      updatedCartItem.querySelectorAll(".quantity-input").forEach(input => {
        input.value = input.getAttribute("data-previous-value");
      });
      renderRecommendedForLastViewedProduct();
      renderRecentlyViewedProducts();
    }
  });
          }
          else{
             let quantityWrappers = cartItem.querySelectorAll(".quantity-input");
          cartItem.querySelector("[data-error-text]").innerHTML = cart.message;
          cartItem.querySelector(".cart-item-error").style.display = "block";
          Array.from(quantityWrappers).forEach(function (quantity) {
            quantity.value = quantity.getAttribute("data-previous-value");
          });
          cartItem.classList.remove("disabled");
            
          }
}

        
        return false;
      }
      const drawerBody = document.querySelector("[data-cart-drwaer-body]");
      if(drawerBody){
      updateCartDrawerContent();
      renderRecommendedForLastViewedProduct();
      renderRecentlyViewedProducts();
      }

      cartCountUpdate(cart.item_count);
      
       if (cart.sections) {
      cartContentUpdate(cart, sectionId);

    }

    });
};
/* Cart change item event end */
if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations
  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");

        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "address_province",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#shipping-wrapper-response")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#address_zip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#address_province").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#shipping-wrapper-response")
        .html('<p class="error-text error">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text success">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#shipping-wrapper-response").html(html).addClass("success").show();
      } else {
        $("#shipping-wrapper-response")
          .html('<p class="error-text error">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();
  document.addEventListener("shopify:section:load", shippingEstimates, false);
}

function stickyformqty() {
  let quantityChange = document.querySelector("[data-quantity-input]");
  if (quantityChange) {
    quantityChange.addEventListener("change", function () {
      document.getElementById("sticky_quantity").value = this.value;
    });
  }
  let quantityInc = document.querySelector("[data-qty-increment]");
  if (quantityInc) {
    quantityInc.addEventListener("click", function (event) {
      let quantityincval = document.querySelector("[data-quantity-input]");
      quantityincval = parseInt(quantityincval.value);
      quantityincval = quantityincval + 1;
      document.getElementById("sticky_quantity").value = quantityincval;
      document.querySelector("[data-quantity-input]").value = quantityincval;
    });
  }

  let quantityDec = document.querySelector("[data-qty-decrement]");
  if (quantityDec) {
    quantityDec.addEventListener("click", function (event) {
      let quantitydecval = document.querySelector("[data-quantity-input]");
      quantitydecval = parseInt(quantitydecval.value);
      quantitydecval = quantitydecval - 1;
      if (quantitydecval > 0) {
        document.getElementById("sticky_quantity").value = quantitydecval;
        document.querySelector("[data-quantity-input]").value = quantityincval;
      }
    });
  }
}

async function fetchAllCartData(variantId) {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const item = cart.items.find((product) => product.variant_id === variantId);
    return item || null; // Return null if not found
  } catch (error) {
    console.error("Error fetching cart:", error);
    return null;
  }
}

function attachMiniCartListeners() {
  // Update via + or - buttons
  document
    .querySelectorAll(".ajax-cart-update.quantity-button")
    .forEach((button) => {
      button.addEventListener("click", () => {
        const input = button.parentElement.querySelector(".quantity-input");
        const line = parseInt(input.dataset.line);
        let quantity = parseInt(input.value);

        if (button.hasAttribute("data-quantity-increment")) {
          quantity++;
        } else if (button.hasAttribute("data-quantity-decrement")) {
          quantity = Math.max(quantity - 1, 0);
        }

        input.value = quantity;
        updateCartItem(line, quantity, input);
      });
    });

  // Update on manual input change
  document
    .querySelectorAll(".ajax-cart-update.quantity-input")
    .forEach((input) => {
      input.addEventListener("change", () => {
        const line = parseInt(input.dataset.line);
        let quantity = parseInt(input.value);
        quantity = isNaN(quantity) || quantity < 0 ? 0 : quantity;
        input.value = quantity;
        updateCartItem(line, quantity, input);
      });
    });
}
   
function updateCartItem(line, quantity, inputElement) {
  const miniCartItem = inputElement.closest(".mini-cart-item");
  const variantId = miniCartItem?.dataset.variant_id;
  if (!variantId || isNaN(quantity)) return;

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then((res) => res.json())
    .then((cart) => {
      if (cart.status) {
        inputElement.setAttribute('disabled', true);
        inputElement.closest('.product-quantity-wrapper')
          ?.querySelectorAll('.quantity-button')
          .forEach(btn => btn.setAttribute('disabled', true));
      }

      cartCountUpdate(cart.item_count);

      const title = document.querySelector(".mini-cart-item h2");
      if (title) title.textContent = `${cart.item_count} Items Added to the cart`;

      const price = parseFloat(
        miniCartItem.querySelector(".popup-cart-title-price .popup-price-orignal").textContent
      );

      const basketTotal = miniCartItem.querySelector(".popup-basket-total .popup-basket-total-price");
      if (basketTotal) basketTotal.textContent = `£${(quantity * price).toFixed(2)}`;

      const minicartpirce = document.querySelector(".my-mini-basket-mobile .popup-basket-total-price");
      if (minicartpirce && cart.total_price) {
        minicartpirce.textContent = `£${(cart.total_price / 100).toFixed(2)}`;
      }
    })
    .catch((error) => console.error("Error updating cart:", error));
}


document.addEventListener("click", function (e) {
  if (e.target.closest(".popup-remove-prd-btn")) {
    const removeBtn = e.target.closest(".popup-remove-prd-btn");
    const dataVariantId = removeBtn.getAttribute("data-variant");

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: dataVariantId,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {

        const productContainer = removeBtn.closest(".popup-prd-main-content");
      if (productContainer) {
        productContainer.remove();
      }
        const popup = document.getElementById("add-to-cart-popup");
       
      })
      .catch((error) => {
        console.error("Error removing product:", error);
      });
  }
});




document.addEventListener('DOMContentLoaded', function () {

    const forms = document.querySelectorAll('form.ajax-add-to-cart');

    forms.forEach(form => {
      const wrapper = form.closest('.product-quantity-with-buy');
       if (!wrapper) return;
      const quantityInput = wrapper.querySelector('.quantity-input');

      const hiddenQuantityInput = form.querySelector('.hidden-quantity-input');
      const plusBtn = wrapper.querySelector('[data-quantity-increment]');
      const minusBtn = wrapper.querySelector('[data-quantity-decrement]');

      if (!quantityInput || !hiddenQuantityInput) return;

      // Clamp and sync function
      const updateQuantity = (newVal) => {
        const min = parseInt(quantityInput.min) || 1;
        const max = parseInt(quantityInput.max) || 1000;
        const clamped = Math.max(min, Math.min(max, newVal));
        quantityInput.value = clamped;
        hiddenQuantityInput.value = clamped;
      };

        // Manual typing sync (input event)
          quantityInput.addEventListener('input', () => {
          updateQuantity(parseInt(quantityInput.value) || 1);
         });

        plusBtn?.addEventListener('click', (event) => {
           
           const val = parseInt(quantityInput.value) || 1;

         });

         minusBtn?.addEventListener('click', (event) => {
          
           const val = parseInt(quantityInput.value) || 1;

         });


    form.addEventListener('submit', function (e) {
        e.preventDefault();


        if (quantityInput && hiddenQuantityInput) {
         hiddenQuantityInput.value = quantityInput.value;
         }

        const formData = new FormData(form);
       formData.delete('properties[_for Delivery By]');


        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          // Update cart drawer content first, then open drawer
          updateCartDrawerContent()
         
          
            .then(() => {
              openCartDrawer();
               renderRecommendedForLastViewedProduct()
               renderRecentlyViewedProducts();
            });
        })
        .catch(err => console.error('Add to cart error:', err));
      });
    });

    function openCartDrawer() {
      const drawer = document.querySelector('#ajax-cart-drawer');
      if (drawer) {
        drawer.classList.add('sidebar-visible');
        drawer.style.display = 'flex'; 
        document.body.classList.add('cart-drawer-open'); 
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    function updateCartDrawerContent() {
      return fetch('/?sections=header,ajax-cart-drawer')
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch cart drawer content');
          return res.text();
        })
        .then(html => {
          const rawHtml = JSON.parse(html)
          const parser = new DOMParser();
          const doc = parser.parseFromString(rawHtml['ajax-cart-drawer'], 'text/html');
          const newContent = doc.querySelector('.cart-drawer-content');
          const currentDrawer = document.querySelector('.cart-drawer-content');

          // for bubble count
          const headerDoc = parser.parseFromString(rawHtml['header'], 'text/html');
          const newBubbleCount = headerDoc.querySelector('.header-icons-link.cart')
          const currentBubbleCount = document.querySelector('.header-icons-link.cart')
          if (newContent && currentDrawer) {
            currentDrawer.innerHTML = newContent.innerHTML;
            currentBubbleCount.innerHTML = newBubbleCount.innerHTML
            getQuantityElement(document.querySelector("[data-cart-drwaer-body]"));
            getCartItemRemoveElements(document.querySelector("[data-cart-drwaer-body]"))
          } else {
            console.error('Cart drawer element not found in fetched content or current page.');
          }
        })
        .catch(err => console.error('Error updating cart drawer:', err));
    }
  });